import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">Mentions Légales</h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Présentation de la plateforme</h2>
              <p className="text-gray-700 mb-4">
                Le site <strong>fenetreslyon.fr</strong> est une <strong>plateforme de mise en relation</strong> entre des particuliers et des professionnels qualifiés dans le domaine de la réparation et de l'entretien de fenêtres dans la région lyonnaise.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>Rôle de la plateforme :</strong> Nous agissons uniquement en tant qu'intermédiaire. Nous ne réalisons pas les prestations de réparation nous-mêmes. Les services sont effectués par des artisans partenaires indépendants.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Éditeur de la plateforme</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Raison sociale :</strong> DFPRO SAS</p>
                <p className="text-gray-700 mb-2"><strong>Forme juridique :</strong> Société par Actions Simplifiée</p>
                <p className="text-gray-700 mb-2"><strong>Capital social :</strong> 10 000 €</p>
                <p className="text-gray-700 mb-2"><strong>Siège social :</strong> 123 Avenue de la République, 69003 Lyon, France</p>
                <p className="text-gray-700 mb-2"><strong>RCS :</strong> Lyon B 123 456 789</p>
                <p className="text-gray-700 mb-2"><strong>SIRET :</strong> 123 456 789 00012</p>
                <p className="text-gray-700 mb-2"><strong>N° TVA intracommunautaire :</strong> FR12 123456789</p>
                <p className="text-gray-700 mb-2"><strong>Email :</strong> <a href="mailto:info@fenetreslyon.fr" className="text-teal-600 hover:text-teal-700">info@fenetreslyon.fr</a></p>
                <p className="text-gray-700 mb-2"><strong>Téléphone :</strong> <a href="tel:0980803684" className="text-teal-600 hover:text-teal-700">09 80 80 36 84</a></p>
              </div>
              <p className="text-gray-700 mt-4">
                <strong>Directeur de la publication :</strong> M. Jean Dupont, Président de DFPRO SAS
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Hébergement</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Hébergeur :</strong> Vercel Inc.</p>
                <p className="text-gray-700 mb-2"><strong>Adresse :</strong> 340 S Lemon Ave #4133, Walnut, CA 91789, USA</p>
                <p className="text-gray-700 mb-2"><strong>Site web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">vercel.com</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Responsabilité de la plateforme</h2>
              <p className="text-gray-700 mb-4">
                <strong>En tant que plateforme de mise en relation :</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Nous ne sommes pas responsables de la qualité des prestations réalisées par les artisans partenaires</li>
                <li>Nous ne sommes pas partie au contrat conclu entre l'utilisateur et le professionnel</li>
                <li>Les artisans partenaires sont des professionnels indépendants, responsables de leurs prestations</li>
                <li>Nous mettons en œuvre les moyens nécessaires pour vérifier les qualifications des professionnels référencés</li>
                <li>Nous ne garantissons pas la disponibilité permanente des professionnels</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Obligations légales des artisans partenaires</h2>
              <p className="text-gray-700 mb-4">
                Les professionnels référencés sur notre plateforme doivent obligatoirement :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Être immatriculés au Registre du Commerce et des Sociétés (RCS) ou au Répertoire des Métiers (RM)</li>
                <li>Disposer d'une assurance responsabilité civile professionnelle et décennale</li>
                <li>Respecter les normes et réglementations en vigueur</li>
                <li>Fournir un devis détaillé avant toute intervention</li>
                <li>Respecter les délais de rétractation légaux (14 jours pour les contrats conclus à distance)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Médiation de la consommation</h2>
              <p className="text-gray-700 mb-4">
                Conformément à l'article L.612-1 du Code de la consommation, nous proposons un dispositif de médiation de la consommation.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Médiateur :</strong> Association des Médiateurs Européens (AME CONSO)</p>
                <p className="text-gray-700 mb-2"><strong>Adresse :</strong> 197 Boulevard Saint-Germain, 75007 Paris</p>
                <p className="text-gray-700 mb-2"><strong>Site web :</strong> <a href="https://www.mediationconso-ame.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">www.mediationconso-ame.com</a></p>
                <p className="text-gray-700 mb-2"><strong>Email :</strong> <a href="mailto:contact@mediationconso-ame.com" className="text-teal-600 hover:text-teal-700">contact@mediationconso-ame.com</a></p>
              </div>
              <p className="text-gray-700 mt-4">
                En cas de litige, vous pouvez également utiliser la plateforme européenne de règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">https://ec.europa.eu/consumers/odr</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Propriété intellectuelle</h2>
              <p className="text-gray-700 mb-4">
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes) est protégé par le droit d'auteur et appartient à DFPRO SAS ou à ses partenaires.
              </p>
              <p className="text-gray-700 mb-4">
                Toute reproduction, représentation, modification, publication ou adaptation totale ou partielle est interdite sans autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Protection des données personnelles</h2>
              <p className="text-gray-700 mb-4">
                Les informations collectées via notre plateforme font l'objet d'un traitement informatique destiné à la mise en relation avec des professionnels qualifiés.
              </p>
              <p className="text-gray-700 mb-4">
                Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données vous concernant.
              </p>
              <p className="text-gray-700 mb-4">
                Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-teal-600 hover:text-teal-700 font-medium">Politique de Confidentialité</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Cookies</h2>
              <p className="text-gray-700 mb-4">
                Notre site utilise des cookies pour améliorer votre expérience de navigation et réaliser des statistiques de visite.
              </p>
              <p className="text-gray-700 mb-4">
                Vous pouvez à tout moment modifier vos préférences via notre bannière de gestion des cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Loi applicable</h2>
              <p className="text-gray-700 mb-4">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact</h2>
              <p className="text-gray-700 mb-4">
                Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Par email : <a href="mailto:info@fenetreslyon.fr" className="text-teal-600 hover:text-teal-700">info@fenetreslyon.fr</a></li>
                <li>Par téléphone : <a href="tel:0980803684" className="text-teal-600 hover:text-teal-700">09 80 80 36 84</a></li>
                <li>Par courrier : DFPRO SAS, 123 Avenue de la République, 69003 Lyon</li>
              </ul>
            </section>

            <p className="text-sm text-gray-500 mt-12 pt-8 border-t border-gray-200">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </div>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      <Footer />
    </div>
  );
}
